export default "__VITE_ASSET__BH$eC18U__"